// FNV-1a over the slug bytes -> HSL with stable saturation/lightness.
// Pure: same input always returns the same colour, no IO.
export interface TeamColor { bg: string; fg: string }

function fnv1a(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function teamColor(slug: string): TeamColor {
  const hue = fnv1a(slug) % 360;
  return { bg: `hsl(${hue}, 60%, 38%)`, fg: "#fff" };
}
